import { useQuery } from "@tanstack/react-query";
import { ProductsAPI } from "api";

const fetchData = (storeId) => {
  return ProductsAPI.get({ params: { storeId: storeId } });
};

// const fetchProducts = (storeId) => {
//   return ProductsAPI.get(`/products?storeId=${storeId}`);
// };

export const useFetchProducts = (storeId) => {
  return useQuery({
    queryKey: ["products", storeId],
    queryFn: () => fetchData(storeId),
    enabled: !!storeId, // 🚀 only fetch when storeId exists
    keepPreviousData: true, // smooth switching
  });
};
